/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

const AppLayout = (props: any) => {
  return (
    <React.Fragment>
      <section className='flex flex-col min-h-screen'>{props.children}</section>
    </React.Fragment>
  )
}

export default AppLayout
